import { useMutation } from "@tanstack/react-query";
import { NavigateOptions } from "@vixi/router";
import api, { endpoints } from "@vixi/api";
import { PlanType, SubscriptionType, SubscriptionCheckoutRequest } from "@vixi/types";
import { AxiosResponse } from "axios";

interface CreateSubscriptionCheckoutOptions {
  planType: PlanType["id"];
  subscriptionType: SubscriptionType["id"];
}

interface CreateSubscriptionCheckoutResponse {
  value: {
    data: string;
    succeeded: boolean;
    errors: any[];
  };
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

const createSubscriptionCheckout = async (data: CreateSubscriptionCheckoutOptions) => {
  const response = (await api.post(
    endpoints.subscriptionCheckout,
    {
      ...data,
      successURL: `${window.location.origin}${"/dashboard" satisfies NavigateOptions["to"]}`,
      failureURL: `${window.location.origin}${"/premium" satisfies NavigateOptions["to"]}`,
    } satisfies SubscriptionCheckoutRequest,
    {
      headers: {
        Accept: "application/octet-stream",
      },
    },
  )) as AxiosResponse<CreateSubscriptionCheckoutResponse>;

  if (response.status !== 200) {
    throw new Error("Failed to initialize payment");
  }

  return response.data;
};

export const useSubscriptionCheckout = () => {
  return useMutation({
    mutationKey: ["create-subscription-checkout"],
    mutationFn: createSubscriptionCheckout,
  });
};
